<script lang="ts" setup>
import type { HTMLAttributes } from "vue";
import { reactiveOmit } from "@vueuse/core";
import {
    RangeCalendarCellTrigger,
    type RangeCalendarCellTriggerProps,
    useForwardProps,
} from "reka-ui";
import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/ui/button";

const props = defineProps<
    RangeCalendarCellTriggerProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = reactiveOmit(props, "class");

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <RangeCalendarCellTrigger
        :class="
            cn(
                buttonVariants({ variant: 'ghost' }),
                'relative h-9 w-9 rounded-full p-0 font-normal data-[selected]:opacity-100 sm:h-10 sm:w-10',
                // Selection Start
                'data-[selection-start]:bg-primary-orange data-[selection-start]:text-base-white data-[selection-start]:hover:bg-primary-orange data-[selection-start]:hover:text-base-white data-[selection-start]:focus:bg-primary-orange data-[selection-start]:focus:text-base-white ',
                // Selection End
                'data-[selection-end]:bg-primary-orange data-[selection-end]:text-base-white data-[selection-end]:hover:bg-primary-orange data-[selection-end]:hover:text-base-white data-[selection-end]:focus:bg-primary-orange data-[selection-end]:focus:text-base-white ',
                // Outside months
                'data-[outside-view]:text-base-black/60 data-[outside-view]:opacity-30  [&[data-outside-view][data-selected]]:text-base-black/60 [&[data-outside-view][data-selected]]:opacity-30 ',
                // Disabled
                'data-[disabled]:text-base-black/60 data-[disabled]:opacity-30 ',
                // Unavailable
                'data-[unavailable]:text-base-white data-[unavailable]:line-through ',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <slot />
    </RangeCalendarCellTrigger>
</template>
